export default "__VITE_ASSET__CnnWSwEY__"